import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toxicity',
  templateUrl: './toxicity.component.html',
  styleUrls: ['./toxicity.component.css']
})
export class ToxicityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
